<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">

            <v-layout column>
                <v-card-title>
                    <v-btn text @click="storePendentes.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Pesquisar"
                        clearable
                        single-line
                    ></v-text-field>
                </v-card-title>

                <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="storePendentes.data"
                    :loading="storePendentes.isLoading"
                    :items-per-page="10"
                    sort-by="nome"
                    :footer-props="footerProps"
                    class="elevation-1"
                >
                    <template style="d-flex" v-slot:item="{ item }">
                        <tr>
                            <td class="hidden-sm-and-down">{{ item.id }}</td>
                            <td>{{ item.titulo }}</td>
                            <td>{{ item.horasEstimadas }}</td>
                            <td>{{ item.horasRealizadas }}</td>
                            <td>{{ item.stringData }}</td>
                            <td>{{ item.strProjetoNome }}</td>
                            <td>{{ item.strClienteNome }}</td>
                            <td class="text-xs-right">
                                <v-btn icon @click="toTarefaDetalhes(item.id)" text><v-icon medium color="green lighter-4">list_alt</v-icon></v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-layout>
        </v-slide-y-transition>
    </v-container>
</template>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import { Store } from '@/utils/Store.js';

export default {
    mounted() {
        EventBus.$on('tarefaInserida', (eventParam) => {
            this.storePendentes.load();
        });
        EventBus.$on('tarefaAlterada', (eventParam) => {
            this.storePendentes.load();
        });
        EventBus.$on('tarefaRemovida', (eventParam) => {
            this.storePendentes.load();
        });
    },
    methods: {
        toTarefaDetalhes(id) {
            EventBus.$emit('showTarefaDetalhes', {
                id: id
            });
        }
    },
    created() {
        this.storePendentes.load();
    },
    data() {
        return {
            storePendentes: new Store({
                url: '/tarefas/Tarefas',
                baseParams: {
                    concluida: false
                },
                listeners: {
                    load: (storeEl) => {
                        storeEl.allData = storeEl.allData.map((element) => {
                            if (element.cliente) {
                                element.strClienteNome = element.cliente.nome;
                            }

                            if (element.projeto) {
                                element.strProjetoNome= element.projeto.nome;
                            }

                            return element;
                        });

                        storeEl.data = JSON.parse(JSON.stringify(storeEl.allData));
                    }
                }
            }),
            isTrue: true,
            search: '',
            footerProps: {
                itemsPerPageOptions:  [5, 10, 25, { text: 'Todos', value: -1 }],
                itemsPerPageText: 'Registros por pagina'
            },
            headers: [
                { text: 'Id', align: 'left', sortable: false, value: 'id', width: '60', class: 'hidden-sm-and-down' },
                { text: 'Titulo', align: 'left', value: 'titulo' },
                { text: 'Horas Estimadas', align: 'left', value: 'horasEstimadas' },
                { text: 'Horas Realizadas', align: 'left', value: 'horasRealizadas' },
                { text: 'Data', align: 'left', value: 'stringData' },
                { text: 'Projeto', align: 'left', value: 'strProjetoNome' },
                { text: 'Cliente', align: 'left', value: 'strClienteNome' },
                { text: '', align: 'center', value: '', width: '60' }
            ]
        };
    }
}
</script>